import { gql } from "@apollo/client";

export default gql`
  mutation DispatchRepeatStudyEmail($input: DispatchRepeatStudyEmailArgs!) {
    dispatchRepeatStudyEmail(input: $input) {
      message
    }
  }
`;
